import { render, staticRenderFns } from "./WfConsumerRecordModal.vue?vue&type=template&id=53ed29e4&scoped=true&"
import script from "./WfConsumerRecordModal.vue?vue&type=script&lang=js&"
export * from "./WfConsumerRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerRecordModal.vue?vue&type=style&index=0&id=53ed29e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed29e4",
  null
  
)

export default component.exports